import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLogin } from '../api/auth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useLogin();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') ?? '/';

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          login.mutate(
            { email: email.trim(), password },
            { onSuccess: () => navigate(next, { replace: true }) },
          );
        }}
        className="w-full max-w-sm bg-white rounded-lg border border-slate-200 shadow-sm p-6"
      >
        <h1 className="text-lg font-semibold mb-1">Sign in to the panel</h1>
        <p className="text-xs text-slate-500 mb-5">
          Use the credentials your administrator gave you.
        </p>

        <label className="block text-xs font-medium text-slate-700 mb-1">Email</label>
        <input
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
          autoFocus
        />

        <label className="mt-3 block text-xs font-medium text-slate-700 mb-1">Password</label>
        <input
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
        />

        {login.error && (
          <div className="mt-3 text-sm text-red-700">
            {(login.error as Error).message === 'Request failed: 401'
              ? 'Wrong email or password.'
              : (login.error as Error).message}
          </div>
        )}

        <button
          type="submit"
          disabled={!email || !password || login.isPending}
          className="mt-5 w-full px-3 py-2 text-sm rounded bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50"
        >
          {login.isPending ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
